<template>
    <v-row justify="space-around">
        <loading :loading="loading"></loading>
        <v-col
            cols="11"
        >
            <v-stepper alt-labels class="elevation-0" :value="current">
                <v-stepper-header class="elevation-0">
                    <v-stepper-step :complete="current > 1" step="1">
                        <span class="stepper-text">
                            {{ $t('view.contract_form.update.steps.office_info')}}
                        </span>
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="current > 2" step="2">
                        <span class="stepper-text">
                            {{ $t('view.contract_form.update.steps.apply_info')}}
                        </span>
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="current > 3" step="3">
                        <span class="stepper-text">
                            {{ $t('view.contract_form.update.steps.request_info')}}
                        </span>
                    </v-stepper-step>
                    <v-divider></v-divider>

                    <v-stepper-step v-if="this.isEkyc"
                        :complete="current > this.shippingAddressInfoStepNum" 
                        :step=this.shippingAddressInfoStepNum>
                        <span class="stepper-text">
                            {{ $t('view.contract_form.update.steps.shipping_address_info')}}
                        </span>
                    </v-stepper-step>
                    <v-divider v-if="this.isEkyc"></v-divider>

                    <v-stepper-step 
                        :complete="current > this.consentStepNum"
                        :step="this.consentStepNum">
                        <span class="stepper-text">
                            {{ $t('view.contract_form.update.steps.consent')}}
                        </span>
                    </v-stepper-step>
                    <v-divider></v-divider>

                    <v-stepper-step 
                        :complete="current > this.confirmStepNum"
                        :step="this.confirmStepNum">
                        <span class="stepper-text">
                            {{ $t('view.contract_form.update.steps.confirm')}}
                        </span>
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                        :complete="current > this.completeStepnum"
                        :step="this.completeStepnum">
                        <span class="stepper-text">
                            {{ $t('view.contract_form.update.steps.complete')}}
                        </span>
                    </v-stepper-step>
                </v-stepper-header>
                <v-divider></v-divider>
                <v-stepper-items>
                    <error-panel ref="errorPanel" :error="hasError"></error-panel>
                    <v-stepper-content step="1" class="pt-2">
                        <v-row class="pt-0 mt-0">
                            <v-col cols="12">
                                <label class="font-weight-bold title ">
                                    {{ $t('view.contract_form.update.steps.office_info')}}
                                </label>
                                <div v-if="this.isEkyc" class="caption font-weight-bold red--text" v-html="$t('view.contract_form.update.messages.standard_plan_message')">
                                </div>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <office-info
                            ref="officeInfo"
                            :getMessage="this.getErrorMessage"
                            :email="email"
                            @submit-complete="onSubmit"
                            @error-occured="showError"
                            @error-fixed="hideError"
                        ></office-info>
                    </v-stepper-content>
                    <v-stepper-content step="2" class="pt-2">
                        <v-row class="pt-0 mt-0">
                            <v-col cols="12">
                                <label class="font-weight-bold title ">
                                    {{ $t('view.contract_form.update.steps.apply_info')}}
                                </label>
                                <!-- <div v-if="!this.isBasic && !this.isEkyc" class="caption font-weight-thin" v-html="$t('view.contract_form.update.messages.select_service_message')">
                                </div> -->
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <apply-info
                            ref="applyInfo"
                            :getMessage="this.getErrorMessage"
                            @on-back="onBack"
                            @submit-complete="onSubmit"
                            @error-occured="showError"
                            @error-fixed="hideError"
                        ></apply-info>
                    </v-stepper-content>

                    <v-stepper-content step="3" class="pt-2">
                        <v-row class="pt-0 mt-0">
                            <v-col cols="12">
                                <label class="font-weight-bold title ">
                                    {{ $t('view.contract_form.update.steps.request_info')}}
                                </label>
                                <div v-if="isRequestInfoEditable()" class="caption font-weight-thin" v-html="$t('view.contract_form.update.messages.request_info_message')">
                                </div>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <request-info
                            ref="requestInfo"
                            :form-data="contractDocument"
                            :getMessage="this.getErrorMessage"
                            @on-back="onBack"
                            @submit-complete="onSubmit"
                            @error-occured="showError"
                            @error-fixed="hideError"
                        ></request-info>
                    </v-stepper-content>

                    <v-stepper-content :step="this.shippingAddressInfoStepNum" class="pt-2">
                        <v-row class="pt-0 mt-0">
                            <v-col cols="12">
                                <label class="font-weight-bold title ">
                                    {{ $t('view.contract_form.update.steps.shipping_address_info')}}
                                </label>
                                <div class="caption font-weight-bold red--text" v-html="$t('view.contract_form.update.messages.shipping_address_info_message')">
                                </div>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <shipping-address-info
                            ref="shippingAddressInfo"
                            :getMessage="this.getErrorMessage"
                            @on-back="onBack"
                            @submit-complete="onSubmit"
                            @error-occured="showError"
                            @error-fixed="hideError"
                        ></shipping-address-info>
                    </v-stepper-content>

                    <v-stepper-content :step="this.consentStepNum" class="pt-2">
                        <v-row class="pt-0 mt-0">
                            <v-col cols="12">
                                <label class="font-weight-bold title ">
                                    {{ $t('view.contract_form.update.steps.consent')}}
                                </label>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <consent
                            :form-data="contractDocument"
                            :getMessage="this.getErrorMessage"
                            @on-back="onBack"
                            @submit-complete="onSubmit"
                            @error-occured="showError"
                            @error-fixed="hideError"
                        ></consent>
                    </v-stepper-content>

                    <v-stepper-content :step="this.confirmStepNum" class="pt-2">
                        <v-row class="pt-0 mt-0">
                            <v-col cols="12">
                                <label class="font-weight-bold title ">
                                    {{ $t('view.contract_form.update.steps.confirm')}}
                                </label>
                                <div class="caption font-weight-thin">
                                    {{ $t('view.contract_form.update.messages.confirm_alert') }}
                                </div>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <confirm
                            :form-data="contractDocument"
                            @on-back="onBack"
                            @submit-complete="submitComplete"
                        ></confirm>
                    </v-stepper-content>

                    <v-stepper-content :step="this.completeStepnum" class="pt-2">
                        <complete :email="email"></complete>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>

        </v-col>
    </v-row>
</template>

<script>
    // Ajax通信ライブラリ
    import axios from 'axios';
    import DatePickerWrapper from "../../components/datepicker/DatePickerWrapper";
    import OfficeInfo from "../../components/contract_form/OfficeInfo";
    import ApplyInfo from "../../components/contract_form/ApplyInfo";
    import RequestInfo from "../../components/contract_form/RequestInfo";
    import ShippingAddressInfo from "../../components/contract_form/ShippingAddressInfo";
    import Confirm from "../../components/contract_form/Confirm";
    import Complete from "../../components/contract_form/Complete";
    import Consent from "../../components/contract_form/Consent";
    import ErrorPanel from "../../components/globals/ErrorPanel";
    import Loading from "../../components/globals/Loading";
    import ValueChecker from "../../../common/src/utils/validation/value_checker";
    const VueScrollTo = require('vue-scrollto');
    import ApplyServiceConst from "../../../common/src/constrains/contract_form/apply_service_const";

    export default {
        components: {
            Loading,
            ErrorPanel, Complete, Confirm, RequestInfo, ShippingAddressInfo, OfficeInfo, ApplyInfo, DatePickerWrapper, Consent},
        data() {
            return {
                current: 1,
                email: '',
                officeInfo: {},
                applyInfo: {},
                requestInfo: {},
                shippingAddressInfo: {},
                shippingAddressInfoStepNum: 0,            
                consentStepNum: 0,
                confirmStepNum: 0,
                completeStepnum: 0,
                hasError: false,
                isUpdate: false,
                isBasic: false,
                isEkyc: false,
                isShippingAddressStepSkip: false,
                loading: false
            };
        },
        computed: {
            contractDocument: function () {
                return {
                    documentId: this.$route.params.documentId,
                    officeInfoRequestEmail: this.email,
                    officeInfoRequestPersonLastName: this.officeInfo['requestPersonLastName'],
                    officeInfoRequestPersonFirstName: this.officeInfo['requestPersonFirstName'],
                    officeInfoRequestPersonKanaLastName: this.officeInfo['requestPersonKanaLastName'],
                    officeInfoRequestPersonKanaFirstName: this.officeInfo['requestPersonKanaFirstName'],
                    officeInfoOfficeNo: this.officeInfo['officeNo'],
                    officeInfoCompanyName: this.officeInfo['companyName'],
                    officeInfoCompanyNameKana: this.officeInfo['companyNameKana'],
                    officeInfoOfficeName: this.officeInfo['officeName'],
                    officeInfoOfficeNameKana: this.officeInfo['officeNameKana'],
                    officeInfoZip1: this.officeInfo['zip1'],
                    officeInfoZip2: this.officeInfo['zip2'],
                    officeInfoAddress1: this.officeInfo['address1'],
                    officeInfoAddress2: this.officeInfo['address2'],
                    officeInfoAddress3: this.officeInfo['address3'],
                    // Standard 法人住所対応
                    officeInfoCorporateName: this.officeInfo['corporateName'],
                    officeInfoCompanyNo: this.officeInfo['companyNo'],
                    officeInfoCorporateZip1: this.officeInfo['corporateZip1'],
                    officeInfoCorporateZip2: this.officeInfo['corporateZip2'],
                    officeInfoCorporateAddress1: this.officeInfo['corporateAddress1'],
                    officeInfoCorporateAddress2: this.officeInfo['corporateAddress2'],
                    officeInfoCorporateAddress3: this.officeInfo['corporateAddress3'],
                    officeInfoTel: this.officeInfo['tel'],
                    officeInfoTantosyaLastName: this.officeInfo['tantosyaLastName'],
                    officeInfoTantosyaFirstName: this.officeInfo['tantosyaFirstName'],
                    officeInfoTantosyaKanaLastName: this.officeInfo['tantosyaKanaLastName'],
                    officeInfoTantosyaKanaFirstName: this.officeInfo['tantosyaKanaFirstName'],
                    officeInfoTantosyaMail: this.officeInfo['tantosyaMail'],
                    // 本人確認をスキップするかどうか
                    personalEkycSkipFlg: this.isShippingAddressStepSkip ? 'true' : '',
                    applyInfoApplyDate: this.applyInfo['applyDate'],
                    applyInfoApplyService: this.applyInfo['applyService'],
                    applyInfoKinoKunrenPeriod: this.applyInfo['kinoKunrenPeriod'],
                    applyInfoApplyCapacity: this.applyInfo['applyCapacity'],
                    applyInfoOralCarePeriod: this.applyInfo['oralCarePeriod'],
                    applyInfoKinoKunrenStartDate: this.applyInfo['kinoKunrenStartDate'],
                    applyInfoOralCareSstartDate: this.applyInfo['oralCareSstartDate'],
                    applyInfoInputNumber: this.applyInfo['inputNumber'],
                    requestInfoCompanyName: this.requestInfo['companyName'],
                    requestInfoOfficeName: this.requestInfo['officeName'],
                    requestInfoZip1: this.requestInfo['zip1'],
                    requestInfoZip2: this.requestInfo['zip2'],
                    requestInfoAddress1: this.requestInfo['address1'],
                    requestInfoAddress2: this.requestInfo['address2'],
                    requestInfoAddress3: this.requestInfo['address3'],
                    requestInfoTel: this.requestInfo['tel'],
                    requestInfoRequestPersonLastName: this.requestInfo['requestPersonLastName'],
                    requestInfoRequestPersonFirstName: this.requestInfo['requestPersonFirstName'],
                    requestInfoRequestEmail: this.requestInfo['requestEmail'],
                    requestInfoHowToRequest: this.requestInfo['howToRequest'],
                    requestInfoHowToSend: this.requestInfo['howToSend'],
                    requestInfoIsReadOnly: this.requestInfo['requestInfoIsReadOnly'],
                    kobetuPriceBookBillWay: this.requestInfo['kobetuPriceBookBillWay'],
                    oralCarePriceBookBillWay: this.requestInfo['oralCarePriceBookBillWay'],
                    requestInfoCompanySameToOfficeInfo: this.requestInfo['requestInfoCompanySameToOfficeInfo'],
                    requestInfoOfficeSameToOfficeInfo: this.requestInfo['requestInfoOfficeSameToOfficeInfo'],
                    requestInfoAddressSameToOfficeInfo: this.requestInfo['requestInfoAddressSameToOfficeInfo'],
                    requestInfoTelSameToOfficeInfo: this.requestInfo['requestInfoTelSameToOfficeInfo'],
                    requestInfoPersonNameSameToOfficeInfo: this.requestInfo['requestInfoPersonNameSameToOfficeInfo'],
                    requestInfoEmailSameToOfficeInfo: this.requestInfo['requestInfoEmailSameToOfficeInfo'],
                    interimRequestInfoOfficeName: this.requestInfo['interimRequestInfoOfficeName'],
                    interimRequestInfoHojinName: this.requestInfo['interimRequestInfoHojinName'],
                    interimRequestInfoZip1: this.requestInfo['interimRequestInfoZip1'],
                    interimRequestInfoZip2: this.requestInfo['interimRequestInfoZip2'],
                    interimRequestInfoAddress1: this.requestInfo['interimRequestInfoAddress1'],
                    interimRequestInfoAddress2: this.requestInfo['interimRequestInfoAddress2'],
                    interimRequestInfoAddress3: this.requestInfo['interimRequestInfoAddress3'],
                    interimRequestInfoTel: this.requestInfo['interimRequestInfoTel'],
                    interimRequestInfoPersonLastName: this.requestInfo['interimRequestInfoPersonLastName'],
                    interimRequestInfoPersonFirstName: this.requestInfo['interimRequestInfoPersonFirstName'],
                    interimRequestInfoWay: this.requestInfo['interimRequestInfoWay'],
                    interimRequestInfoNotification: this.requestInfo['interimRequestInfoNotification'],
                    oralCarePriceBookData: this.applyInfo['oralCarePriceBookData'],
                    kobetuPriceBookData: this.applyInfo['kobetuPriceBookData'],
                    kobetuTokubetuDetail: this.applyInfo['kobetuTokubetuDetail'],
                    oralCareTokubetuDetail: this.applyInfo['oralCareTokubetuDetail'],
                    kobetuPriceBook2Id: this.applyInfo['kobetuPriceBook2Id'],
                    oralCarePriceBook2Id: this.applyInfo['oralCarePriceBook2Id'],
                    kobetuFreePeriod: this.applyInfo['kobetuFreePeriod'],
                    oralCareFreePeriod: this.applyInfo['oralCareFreePeriod'],
                    oralCcarePrice: this.applyInfo['oralCcarePrice'],
                    inputPrice: this.applyInfo['inputPrice'],
                    kobetuPrice: this.applyInfo['kobetuPrice'],
                    kobetuPriceBook2Description: this.applyInfo['kobetuPriceBook2Description'],
                    oralCarePriceBook2Description: this.applyInfo['oralCarePriceBook2Description'],
                    kobetuProductPlanName: this.applyInfo['kobetuProductPlanName'],
                    oralCareProductPlanName: this.applyInfo['oralCareProductPlanName'],
                    oralCarePriceBookUrl: this.applyInfo['oralCarePriceBookUrl'],
                    kobetuPriceBookUrl: this.applyInfo['kobetuPriceBookUrl'],
                    kobetuPriceBookMonth: this.applyInfo['kobetuPriceBookMonth'],
                    oralCarePriceBookMonth: this.applyInfo['oralCarePriceBookMonth'],
                    // 配送先情報
                    shippingAddressInfoCompanyName: this.shippingAddressInfo['companyName'],
                    shippingAddressInfoOfficeName: this.shippingAddressInfo['officeName'],
                    shippingAddressInfoZip1: this.shippingAddressInfo['zip1'],
                    shippingAddressInfoZip2: this.shippingAddressInfo['zip2'],
                    shippingAddressInfoAddress1: this.shippingAddressInfo['address1'],
                    shippingAddressInfoAddress2: this.shippingAddressInfo['address2'],
                    shippingAddressInfoAddress3: this.shippingAddressInfo['address3'],
                    shippingAddressInfoTel: this.shippingAddressInfo['tel'],
                    shippingAddressInfoPersonLastName: this.shippingAddressInfo['shippingAddressInfoPersonLastName'],
                    shippingAddressInfoPersonFirstName: this.shippingAddressInfo['shippingAddressInfoPersonFirstName'],
                    shippingAddressInfoCompanySameToOfficeInfo: this.shippingAddressInfo['shippingAddressInfoCompanySameToOfficeInfo'],
                    shippingAddressInfoOfficeSameToOfficeInfo: this.shippingAddressInfo['shippingAddressInfoOfficeSameToOfficeInfo'],
                    shippingAddressInfoAddressSameToOfficeInfo: this.shippingAddressInfo['shippingAddressInfoAddressSameToOfficeInfo'],
                    shippingAddressInfoTelSameToOfficeInfo: this.shippingAddressInfo['shippingAddressInfoTelSameToOfficeInfo'],
                    shippingAddressInfoPersonNameSameToOfficeInfo: this.shippingAddressInfo['shippingAddressInfoPersonNameSameToOfficeInfo'],
                    shippingAddressInfo: this.shippingAddressInfo['shippingAddressInfoIsReadOnly'],
                    // アップデート対応
                    toUpgradePriceBook2Id: this.applyInfo['toUpgradePriceBook2Id'],
                    toUpgradeTokubetuDetail: this.applyInfo['toUpgradeTokubetuDetail'],
                    toUpgradePriceBookData: this.applyInfo['toUpgradePriceBookData'],
                    toUpgradeData: this.applyInfo['toUpgradeData'],
                    toUpgradeSelectedItem: this.applyInfo['toUpgradeSelectedItem'],
                    currentContractStartDate: this.applyInfo['currentContractStartDate'],
                    currentContractEndDate: this.applyInfo['currentContractEndDate'],
                    toUpgradeStartDate: this.applyInfo['toUpgradeStartDate'],
                    toUpgradePeriod: this.applyInfo['toUpgradePeriod'],
                    previousPlan: this.applyInfo['previousPlan'],
                    contractPlan: this.applyInfo['contractPlan'],
                    toUpgradeCapacity: this.applyInfo['toUpgradeCapacity'],
                    toUpradePlanPeriodStr: this.applyInfo['toUpradePlanPeriodStr'],
                    toUpgradePrice: this.applyInfo['toUpgradePrice'],
                    // basic用
                    applyInfoBasicStartDate: this.applyInfo['basicStartDate'],
                    basicPriceBookBillWay: this.requestInfo['basicPriceBookBillWay'],
                    basicPriceBookData: this.applyInfo['basicPriceBookData'],
                    basicTokubetuDetail: this.applyInfo['basicTokubetuDetail'],
                    basicPriceBook2Id: this.applyInfo['basicPriceBook2Id'],
                    basicFreePeriod: this.applyInfo['basicFreePeriod'],
                    basicPrice: this.applyInfo['basicPrice'],
                    basicPriceBook2Description: this.applyInfo['basicPriceBook2Description'],
                    basicProductPlanName: this.applyInfo['basicProductPlanName'],
                    basicPriceBookUrl: this.applyInfo['basicPriceBookUrl'],
                    basicPriceBookMonth: this.applyInfo['basicPriceBookMonth'],
                    applyInfoApplyCapacityBasic: this.applyInfo['applyCapacityBasic'],
                    // entry用
                    applyInfoEntryStartDate: this.applyInfo['entryStartDate'],
                    entryPriceBookBillWay: this.requestInfo['entryPriceBookBillWay'],
                    entryPriceBookData: this.applyInfo['entryPriceBookData'],
                    entryTokubetuDetail: this.applyInfo['entryTokubetuDetail'],
                    entryPriceBook2Id: this.applyInfo['entryPriceBook2Id'],
                    entryFreePeriod: this.applyInfo['entryFreePeriod'],
                    entryPrice: this.applyInfo['entryPrice'],
                    entryPriceBook2Description: this.applyInfo['entryPriceBook2Description'],
                    entryProductPlanName: this.applyInfo['entryProductPlanName'],
                    entryPriceBookUrl: this.applyInfo['entryPriceBookUrl'],
                    entryPriceBookMonth: this.applyInfo['entryPriceBookMonth'],
                    // medium用
                    applyInfoMediumStartDate: this.applyInfo['mediumStartDate'],
                    mediumPriceBookBillWay: this.requestInfo['mediumPriceBookBillWay'],
                    mediumPriceBookData: this.applyInfo['mediumPriceBookData'],
                    mediumTokubetuDetail: this.applyInfo['mediumTokubetuDetail'],
                    mediumPriceBook2Id: this.applyInfo['mediumPriceBook2Id'],
                    mediumFreePeriod: this.applyInfo['mediumFreePeriod'],
                    mediumPrice: this.applyInfo['mediumPrice'],
                    mediumPriceBook2Description: this.applyInfo['mediumPriceBook2Description'],
                    mediumProductPlanName: this.applyInfo['mediumProductPlanName'],
                    mediumPriceBookUrl: this.applyInfo['mediumPriceBookUrl'],
                    mediumPriceBookMonth: this.applyInfo['mediumPriceBookMonth'],
                    applyInfoApplyCapacityMedium: this.applyInfo['applyCapacityMedium'],
                    // standard用
                    applyInfoStandardStartDate: this.applyInfo['standardStartDate'],
                    standardPriceBookBillWay: this.requestInfo['standardPriceBookBillWay'],
                    standardPriceBookData: this.applyInfo['standardPriceBookData'],
                    standardTokubetuDetail: this.applyInfo['standardTokubetuDetail'],
                    standardPriceBook2Id: this.applyInfo['standardPriceBook2Id'],
                    standardFreePeriod: this.applyInfo['standardFreePeriod'],
                    standardPrice: this.applyInfo['standardPrice'],
                    standardPriceBook2Description: this.applyInfo['standardPriceBook2Description'],
                    standardProductPlanName: this.applyInfo['standardProductPlanName'],
                    standardPriceBookUrl: this.applyInfo['standardPriceBookUrl'],
                    standardPriceBookMonth: this.applyInfo['standardPriceBookMonth'],
                    applyInfoApplyCapacityStandard: this.applyInfo['applyCapacityStandard'],
                    // professional用
                    applyInfoProfessionalStartDate: this.applyInfo['professionalStartDate'],
                    professionalPriceBookBillWay: this.requestInfo['professionalPriceBookBillWay'],
                    professionalPriceBookData: this.applyInfo['professionalPriceBookData'],
                    professionalTokubetuDetail: this.applyInfo['professionalTokubetuDetail'],
                    professionalPriceBook2Id: this.applyInfo['professionalPriceBook2Id'],
                    professionalFreePeriod: this.applyInfo['professionalFreePeriod'],
                    professionalPrice: this.applyInfo['professionalPrice'],
                    professionalPriceBook2Description: this.applyInfo['professionalPriceBook2Description'],
                    professionalProductPlanName: this.applyInfo['professionalProductPlanName'],
                    professionalPriceBookUrl: this.applyInfo['professionalPriceBookUrl'],
                    professionalPriceBookMonth: this.applyInfo['professionalPriceBookMonth'],
                    applyInfoApplyCapacityProfessional: this.applyInfo['applyCapacityProfessional'],
                    // Basicアップグレード用
                    validUpgradeToStandardFlg: this.applyInfo['validUpgradeToStandardFlg'],
                    upgradeToStandardBaseContractEndDate: this.applyInfo['upgradeToStandardBaseContractEndDate'],
                    upgradeToStandardData: this.applyInfo['upgradeToStandardData'],
                    upgradeToStandardFamilyName: this.applyInfo['upgradeToStandardFamilyName'],
                    upgradeToStandardPriceBookData: this.applyInfo['upgradeToStandardPriceBookData'],
                    upgradeToStandardTokubetuDetail: this.applyInfo['upgradeToStandardTokubetuDetail'],
                    standardProductId: this.applyInfo['standardProductId'],
                    // Tablet単体申込み対応
                    additionalTabletPriceBook2Id: this.applyInfo['additionalTabletPriceBook2Id'],
                    applyInfoAdditionalTabletStartDate: this.applyInfo['additionalTabletStartDate'],
                    additionalTabletTokubetuDetail: this.applyInfo['additionalTabletTokubetuDetail'],
                    additionalTablets: this.applyInfo['additionalTablets'],
                    displayDataTableObj: this.applyInfo['displayDataTableObj'],
                    // モーションAI用
                    applyInfoMotionAiStartDate: this.applyInfo['motionAiStartDate'],
                    motionAiPriceBookBillWay: this.requestInfo['motionAiPriceBookBillWay'],
                    motionAiPriceBookData: this.applyInfo['motionAiPriceBookData'],
                    motionAiTokubetuDetail: this.applyInfo['motionAiTokubetuDetail'],
                    motionAiPriceBook2Id: this.applyInfo['motionAiPriceBook2Id'],
                    motionAiFreePeriod: this.applyInfo['motionAiFreePeriod'],
                    motionAiPrice: this.applyInfo['motionAiPrice'],
                    motionAiPriceBook2Description: this.applyInfo['motionAiPriceBook2Description'],
                    motionAiProductPlanName: this.applyInfo['motionAiProductPlanName'],
                    motionAiPriceBookUrl: this.applyInfo['motionAiPriceBookUrl'],
                    motionAiPriceBookMonth: this.applyInfo['motionAiPriceBookMonth'],
                    // 旧Standard用
                    applyInfoOldStandardStartDate: this.applyInfo['oldStandardStartDate'],
                    oldStandardPriceBookBillWay: this.requestInfo['oldStandardPriceBookBillWay'],
                    oldStandardPriceBookData: this.applyInfo['oldStandardPriceBookData'],
                    oldStandardTokubetuDetail: this.applyInfo['oldStandardTokubetuDetail'],
                    oldStandardPriceBook2Id: this.applyInfo['oldStandardPriceBook2Id'],
                    oldStandardFreePeriod: this.applyInfo['oldStandardFreePeriod'],
                    oldStandardPrice: this.applyInfo['oldStandardPrice'],
                    oldStandardPriceBook2Description: this.applyInfo['oldStandardPriceBook2Description'],
                    oldStandardProductPlanName: this.applyInfo['oldStandardProductPlanName'],
                    oldStandardPriceBookUrl: this.applyInfo['oldStandardPriceBookUrl'],
                    oldStandardPriceBookMonth: this.applyInfo['oldStandardPriceBookMonth'],
                    applyInfoApplyCapacityOldStandard: this.applyInfo['applyCapacityOldStandard']
                };
            }
        },
        mounted: function () {
            this.$emit('title-change', '');
            this.loading = true;
            if (!this.$route.params.documentId) {
                this.loading = false;
                this.$router.push({path: '/'});
            }
            let self_ = this;
            let url_ = this.$invokeUrlMaker.create(`get/${this.$route.params.documentId}`);
            axios.get(url_).then(function (res) {
                if (!res.data.key) {
                    self_.$router.push({path: '/'});
                }
                self_.email = res.data.key;
                self_.setInitialData(res.data.data);
                self_.loading = false;
            }).catch(function (e) {
                self_.$router.push({path: '/'});
                self_.loading = false;
            })
        },
        methods: {
            setInitialData(data) {
                if(!data) {
                    // For IE 11.. 
                    this.$refs.officeInfo.setData({});
                    return;
                }
                this.isUpdate = true;
                // 本人確認が必要かどうか
                this.isShippingAddressStepSkip = ValueChecker.isPresent(data['personalEkycSkipFlg']);
                this.officeInfo['requestPersonLastName'] = data['officeInfoRequestPersonLastName'];
                this.officeInfo['requestPersonFirstName'] = data['officeInfoRequestPersonFirstName'];
                this.officeInfo['requestPersonKanaLastName'] = data['officeInfoRequestPersonKanaLastName'];
                this.officeInfo['requestPersonKanaFirstName'] = data['officeInfoRequestPersonKanaFirstName'];
                this.officeInfo['officeNo'] = data['officeInfoOfficeNo'];
                this.officeInfo['companyName'] = data['officeInfoCompanyName'];
                this.officeInfo['companyNameKana'] = data['officeInfoCompanyNameKana'];
                this.officeInfo['officeName'] = data['officeInfoOfficeName'];
                this.officeInfo['officeNameKana'] = data['officeInfoOfficeNameKana'];
                this.officeInfo['zip1'] = data['officeInfoZip1'];
                this.officeInfo['zip2'] = data['officeInfoZip2'];
                this.officeInfo['address1'] = data['officeInfoAddress1'];
                this.officeInfo['address2'] = data['officeInfoAddress2'];
                this.officeInfo['address3'] = data['officeInfoAddress3'];
                this.officeInfo['corporateName'] = data['officeInfoCorporateName'];
                this.officeInfo['companyNo'] = data['officeInfoCompanyNo'];
                this.officeInfo['corporateZip1'] = data['officeInfoCorporateZip1'];
                this.officeInfo['corporateZip2'] = data['officeInfoCorporateZip2'];
                this.officeInfo['corporateAddress1'] = data['officeInfoCorporateAddress1'];
                this.officeInfo['corporateAddress2'] = data['officeInfoCorporateAddress2'];
                this.officeInfo['corporateAddress3'] = data['officeInfoCorporateAddress3'];
                this.officeInfo['tel'] = data['officeInfoTel'];
                this.officeInfo['tantosyaLastName'] = data['officeInfoTantosyaLastName'];
                this.officeInfo['tantosyaFirstName'] = data['officeInfoTantosyaFirstName'];
                this.officeInfo['tantosyaKanaLastName'] = data['officeInfoTantosyaKanaLastName'];
                this.officeInfo['tantosyaKanaFirstName'] = data['officeInfoTantosyaKanaFirstName'];
                this.officeInfo['tantosyaMail'] = data['officeInfoTantosyaMail'];
                this.$refs.officeInfo.setData(this.officeInfo);
                // 申込日は、初回提出日のみ管理する。
                this.applyInfo['applyDate'] = data['applyInfoApplyDate'];
                this.applyInfo['applyService'] = data['applyInfoApplyService'];
                this.applyInfo['kinoKunrenPeriod'] = data['applyInfoKinoKunrenPeriod'];
                this.applyInfo['applyCapacity'] = data['applyInfoApplyCapacity'];
                this.applyInfo['oralCarePeriod'] = data['applyInfoOralCarePeriod'];
                this.applyInfo['kinoKunrenStartDate'] = data['applyInfoKinoKunrenStartDate'];
                this.applyInfo['oralCareSstartDate'] = data['applyInfoOralCareSstartDate'];
                this.applyInfo['inputNumber'] = data['applyInfoInputNumber'];
                this.applyInfo['oralCarePriceBook2Description'] = data['oralCarePriceBook2Description'];
                this.applyInfo['kobetuPriceBook2Description'] = data['kobetuPriceBook2Description'];
                this.applyInfo['kobetuPriceBook2Id'] = data['kobetuPriceBook2Id'];
                this.applyInfo['oralCarePriceBook2Id'] = data['oralCarePriceBook2Id'];
                this.applyInfo['inputPrice'] = data['inputPrice'];
                this.applyInfo['kobetuPrice'] = data['kobetuPrice'];
                this.applyInfo['oralCcarePrice'] = data['oralCcarePrice'];
                this.applyInfo['oralCareFreePeriod'] = data['oralCareFreePeriod'];
                this.applyInfo['kobetuFreePeriod'] = data['kobetuFreePeriod'];
                this.applyInfo['kobetuProductPlanName'] = data['kobetuProductPlanName'];
                this.applyInfo['oralCareProductPlanName'] = data['oralCareProductPlanName'];
                if(data['oralCarePriceBookData']) {
                    this.applyInfo['oralCarePriceBookData'] = data['oralCarePriceBookData'];
                }
                if(data['kobetuPriceBookData']) {
                    this.applyInfo['kobetuPriceBookData'] = data['kobetuPriceBookData'];
                }
                this.applyInfo['kobetuTokubetuDetail'] = data['kobetuTokubetuDetail'];
                this.applyInfo['oralCareTokubetuDetail'] = data['oralCareTokubetuDetail'];
                this.applyInfo['kobetuPriceBookUrl'] = data['kobetuPriceBookUrl'];
                this.applyInfo['oralCarePriceBookUrl'] = data['oralCarePriceBookUrl'];
                this.applyInfo['kobetuPriceBookMonth'] = data['kobetuPriceBookMonth'];
                this.applyInfo['oralCarePriceBookMonth'] = data['oralCarePriceBookMonth'];
                // アップデート対応
                this.applyInfo['toUpgradePriceBook2Id'] = data['toUpgradePriceBook2Id'];
                this.applyInfo['toUpgradeTokubetuDetail'] = data['toUpgradeTokubetuDetail'];
                if(data['toUpgradePriceBookData']) {
                    this.applyInfo['toUpgradePriceBookData'] = data['toUpgradePriceBookData'];
                }
                if(data['toUpgradeData']) {
                    this.applyInfo['toUpgradeData'] = data['toUpgradeData'];
                }
                this.applyInfo['toUpgradeSelectedItem'] = data['toUpgradeSelectedItem'];
                this.applyInfo['currentContractStartDate'] = data['currentContractStartDate'];
                this.applyInfo['currentContractEndDate'] = data['currentContractEndDate'];
                this.applyInfo['previousPlan'] = data['previousPlan'];
                this.applyInfo['contractPlan'] = data['contractPlan'];
                this.applyInfo['toUpgradeStartDate'] = data['toUpgradeStartDate'];
                this.applyInfo['toUpgradePeriod'] = data['toUpgradePeriod'];
                this.applyInfo['toUpgradeCapacity'] = data['toUpgradeCapacity'];
                this.applyInfo['toUpradePlanPeriodStr'] = data['toUpradePlanPeriodStr'];
                this.applyInfo['toUpgradePrice'] = data['toUpgradePrice'];
                this.applyInfo['oldStandardStartDate'] = data['applyInfoOldStandardStartDate'];
                // toUpgradeData: toUpgradeData[]
                // toUpgradeStartDate: string
                // toUpgradePeriod: string
                // basic対応
                this.applyInfo['basicPriceBook2Description'] = data['basicPriceBook2Description'];
                this.applyInfo['basicPriceBook2Id'] = data['basicPriceBook2Id'];
                this.applyInfo['basicPrice'] = data['basicPrice'];
                this.applyInfo['basicProductPlanName'] = data['basicProductPlanName'];
                if(data['basicPriceBookData']) {
                    this.applyInfo['basicPriceBookData'] = data['basicPriceBookData'];
                }
                this.applyInfo['basicTokubetuDetail'] = data['basicTokubetuDetail'];
                this.applyInfo['basicPriceBookUrl'] = data['basicPriceBookUrl'];
                this.applyInfo['basicPriceBookMonth'] = data['basicPriceBookMonth'];
                this.applyInfo['applyCapacityBasic'] = data['applyInfoApplyCapacityBasic'];
                this.applyInfo['basicStartDate'] = data['applyInfoBasicStartDate'];
                // entry対応
                this.applyInfo['entryPriceBook2Description'] = data['entryPriceBook2Description'];
                this.applyInfo['entryPriceBook2Id'] = data['entryPriceBook2Id'];
                this.applyInfo['entryPrice'] = data['entryPrice'];
                this.applyInfo['entryProductPlanName'] = data['entryProductPlanName'];
                if(data['entryPriceBookData']) {
                    this.applyInfo['entryPriceBookData'] = data['entryPriceBookData'];
                }
                this.applyInfo['entryTokubetuDetail'] = data['entryTokubetuDetail'];
                this.applyInfo['entryPriceBookUrl'] = data['entryPriceBookUrl'];
                this.applyInfo['entryPriceBookMonth'] = data['entryPriceBookMonth'];
                this.applyInfo['entryStartDate'] = data['applyInfoEntryStartDate'];
                // medium対応
                this.applyInfo['mediumPriceBook2Description'] = data['mediumPriceBook2Description'];
                this.applyInfo['mediumPriceBook2Id'] = data['mediumPriceBook2Id'];
                this.applyInfo['mediumPrice'] = data['mediumPrice'];
                this.applyInfo['mediumProductPlanName'] = data['mediumProductPlanName'];
                if(data['mediumPriceBookData']) {
                    this.applyInfo['mediumPriceBookData'] = data['mediumPriceBookData'];
                }
                this.applyInfo['mediumTokubetuDetail'] = data['mediumTokubetuDetail'];
                this.applyInfo['mediumPriceBookUrl'] = data['mediumPriceBookUrl'];
                this.applyInfo['mediumPriceBookMonth'] = data['mediumPriceBookMonth'];
                this.applyInfo['applyCapacityMedium'] = data['applyInfoApplyCapacityMedium'];
                this.applyInfo['mediumStartDate'] = data['applyInfoMediumStartDate'];
                // standard対応
                this.applyInfo['standardPriceBook2Description'] = data['standardPriceBook2Description'];
                this.applyInfo['standardPriceBook2Id'] = ValueChecker.isPresent(data['standardPriceBook2Id']) ? data['standardPriceBook2Id'] : data['upgradeToStandardPriceBook2Id'];
                this.applyInfo['standardPrice'] = data['standardPrice'];
                this.applyInfo['standardProductPlanName'] = data['standardProductPlanName'];
                if (data['standardPriceBookData']) {
                    this.applyInfo['standardPriceBookData'] = data['standardPriceBookData'];
                }
                this.applyInfo['standardTokubetuDetail'] = data['standardTokubetuDetail'];
                this.applyInfo['standardPriceBookUrl'] = data['standardPriceBookUrl'];
                this.applyInfo['standardPriceBookMonth'] = data['standardPriceBookMonth'];
                this.applyInfo['applyCapacityStandard'] = data['applyInfoApplyCapacityStandard'];
                this.applyInfo['standardStartDate'] = data['applyInfoStandardStartDate'];
                // professional対応
                this.applyInfo['professionalPriceBook2Description'] = data['professionalPriceBook2Description'];
                this.applyInfo['professionalPriceBook2Id'] = ValueChecker.isPresent(data['professionalPriceBook2Id']) ? data['professionalPriceBook2Id'] : data['upgradeToProfessionalPriceBook2Id'];
                this.applyInfo['professionalPrice'] = data['professionalPrice'];
                this.applyInfo['professionalProductPlanName'] = data['professionalProductPlanName'];
                if (data['professionalPriceBookData']) {
                    this.applyInfo['professionalPriceBookData'] = data['professionalPriceBookData'];
                }
                this.applyInfo['professionalTokubetuDetail'] = data['professionalTokubetuDetail'];
                this.applyInfo['professionalPriceBookUrl'] = data['professionalPriceBookUrl'];
                this.applyInfo['professionalPriceBookMonth'] = data['professionalPriceBookMonth'];
                this.applyInfo['applyCapacityProfessional'] = data['applyInfoApplyCapacityProfessional'];
                this.applyInfo['professionalStartDate'] = data['applyInfoProfessionalStartDate'];
                // Basicアップグレード対応
                this.applyInfo['validUpgradeToStandardFlg'] = data['validUpgradeToStandardFlg'];
                this.applyInfo['upgradeToStandardBaseContractEndDate'] = data['upgradeToStandardBaseContractEndDate'];
                if (data['upgradeToStandardData']) {
                    this.applyInfo['upgradeToStandardData'] = data['upgradeToStandardData'];
                }
                if (data['upgradeToStandardFamilyName']) {
                    this.applyInfo['upgradeToStandardFamilyName'] = data['upgradeToStandardFamilyName'];
                }
                if (data['upgradeToStandardPriceBookData']) {
                    this.applyInfo['upgradeToStandardPriceBookData'] = data['upgradeToStandardPriceBookData'];
                }
                this.applyInfo['upgradeToStandardTokubetuDetail'] = data['upgradeToStandardTokubetuDetail'];
                this.applyInfo['standardProductId'] = data['standardProductId'];
                // Tablet単体申込み対応
                this.applyInfo['additionalTabletPriceBook2Id'] = data['additionalTabletPriceBook2Id'];
                this.applyInfo['additionalTablets'] = data['additionalTablets'];
                this.applyInfo['additionalTabletStartDate'] = data['applyInfoAdditionalTabletStartDate'];
                this.applyInfo['additionalTabletTokubetuDetail'] = data['additionalTabletTokubetuDetail'];
                if (data['displayDataTableObj']) {
                    this.applyInfo['displayDataTableObj'] = data['displayDataTableObj'];
                }
                // モーションAI対応
                this.applyInfo['motionAiPriceBook2Description'] = data['motionAiPriceBook2Description'];
                this.applyInfo['motionAiPriceBook2Id'] = data['motionAiPriceBook2Id'];
                this.applyInfo['motionAiPrice'] = data['motionAiPrice'];
                this.applyInfo['motionAiProductPlanName'] = data['motionAiProductPlanName'];
                if (data['motionAiPriceBookData']) {
                    this.applyInfo['motionAiPriceBookData'] = data['motionAiPriceBookData'];
                }
                this.applyInfo['motionAiTokubetuDetail'] = data['motionAiTokubetuDetail'];
                this.applyInfo['motionAiPriceBookUrl'] = data['motionAiPriceBookUrl'];
                this.applyInfo['motionAiPriceBookMonth'] = data['motionAiPriceBookMonth'];
                this.applyInfo['motionAiStartDate'] = data['applyInfoMotionAiStartDate'];
                // 旧Standard対応
                this.applyInfo['oldStandardPriceBook2Description'] = data['oldStandardPriceBook2Description'];
                this.applyInfo['oldStandardPriceBook2Id'] = data['oldStandardPriceBook2Id'];
                this.applyInfo['oldStandardPrice'] = data['oldStandardPrice'];
                this.applyInfo['oldStandardProductPlanName'] = data['oldStandardProductPlanName'];
                if(data['oldStandardPriceBookData']) {
                    this.applyInfo['oldStandardPriceBookData'] = data['oldStandardPriceBookData'];
                }
                this.applyInfo['oldStandardTokubetuDetail'] = data['oldStandardTokubetuDetail'];
                this.applyInfo['oldStandardPriceBookUrl'] = data['oldStandardPriceBookUrl'];
                this.applyInfo['oldStandardPriceBookMonth'] = data['oldStandardPriceBookMonth'];
                this.applyInfo['applyCapacityOldStandard'] = data['applyInfoApplyCapacityOldStandard'];
                this.applyInfo['oldStandardStartDate'] = data['applyInfoOldStandardStartDate'];
                // TODO: ステッパーの順番決めを関数として切り出す
                // TODO: if分岐をswitch文に変更する
                if(!this.applyInfo['applyService'].length) {
                    if(ValueChecker.isPresent(this.applyInfo['kobetuPriceBook2Id'])) {
                        this.applyInfo['applyService'].push(ApplyServiceConst.KOBETSU);
                    }
                    if(ValueChecker.isPresent(this.applyInfo['oralCarePriceBook2Id'])) {
                        this.applyInfo['applyService'].push(ApplyServiceConst.ORAL_CARE);
                    }
                    // アップグレード対応
                    if (ValueChecker.isPresent(this.applyInfo['toUpgradePriceBook2Id'])) {
                        this.applyInfo['applyService'].push(ApplyServiceConst.UPGRADE); 
                        if (this.isShippingAddressStepSkip) {
                            this.isEkyc = false;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.consentStepNum = 4;
                            this.confirmStepNum = 5;
                            this.completeStepnum = 6;
                        } else {
                            this.isEkyc = true;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.shippingAddressInfoStepNum = 4;
                            this.consentStepNum = 5;
                            this.confirmStepNum = 6;
                            this.completeStepnum = 7;
                        }
                    }
                    // basic対応
                    if (ValueChecker.isPresent(this.applyInfo['basicPriceBook2Id'])) {
                        this.applyInfo['applyService'].push(ApplyServiceConst.BASIC);
                        this.isEkyc = false;
                        this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                        // ステッパーの順番を決める
                        this.consentStepNum = 4;
                        this.confirmStepNum = 5;
                        this.completeStepnum = 6;
                    }
                    // entry対応
                    if (ValueChecker.isPresent(this.applyInfo['entryPriceBook2Id'])) {
                        this.applyInfo['applyService'].push(ApplyServiceConst.ENTRY);
                        if (this.isShippingAddressStepSkip) {
                            this.isEkyc = false;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.consentStepNum = 4;
                            this.confirmStepNum = 5;
                            this.completeStepnum = 6;
                        } else {
                            this.isEkyc = true;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.shippingAddressInfoStepNum = 4;
                            this.consentStepNum = 5;
                            this.confirmStepNum = 6;
                            this.completeStepnum = 7;
                        }
                    }
                    // モーションAI対応
                    if (ValueChecker.isPresent(this.applyInfo['motionAiPriceBook2Id'])) {
                        this.applyInfo['applyService'].push(ApplyServiceConst.MOTION_AI);
                        this.isEkyc = false;
                        // モーションAI単体の場合もステッパーの順番等はBasicと同等
                        this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                        // ステッパーの順番を決める
                        this.consentStepNum = 4;
                        this.confirmStepNum = 5;
                        this.completeStepnum = 6;
                    }
                    // medium対応
                    if (ValueChecker.isPresent(this.applyInfo['mediumPriceBook2Id'])) {
                        this.applyInfo['applyService'].push(ApplyServiceConst.MEDIUM);
                        if (this.isShippingAddressStepSkip) {
                            this.isEkyc = false;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.consentStepNum = 4;
                            this.confirmStepNum = 5;
                            this.completeStepnum = 6;
                        } else {
                            this.isEkyc = true;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.shippingAddressInfoStepNum = 4;
                            this.consentStepNum = 5;
                            this.confirmStepNum = 6;
                            this.completeStepnum = 7;
                        }
                    }
                    // standard対応
                    let upgradeToStandardFlg = ValueChecker.isPresent(this.applyInfo['validUpgradeToStandardFlg']) ? 
                    JSON.parse(this.applyInfo['validUpgradeToStandardFlg'].toLowerCase()) :
                    null;
                    if(ValueChecker.isPresent(this.applyInfo['standardPriceBook2Id']) && !upgradeToStandardFlg) {
                        this.applyInfo['applyService'].push(ApplyServiceConst.STANDARD);
                        if (this.isShippingAddressStepSkip) {
                            this.isEkyc = false;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.consentStepNum = 4;
                            this.confirmStepNum = 5;
                            this.completeStepnum = 6;
                        } else {
                            this.isEkyc = true;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.shippingAddressInfoStepNum = 4;
                            this.consentStepNum = 5;
                            this.confirmStepNum = 6;
                            this.completeStepnum = 7;
                        }
                    } 
                    // Basicアップグレード対応
                    if (upgradeToStandardFlg) {
                        this.applyInfo['applyService'].push(ApplyServiceConst.UPGRADE_TO_STANDARD);
                        this.isEkyc = true;
                        this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                        // ステッパーの順番を決める
                        this.shippingAddressInfoStepNum = 4;
                        this.consentStepNum = 5;
                        this.confirmStepNum = 6;
                        this.completeStepnum = 7;
                    } 
                    if (ValueChecker.isPresent(this.applyInfo['professionalPriceBook2Id'])) {
                        this.applyInfo['applyService'].push(ApplyServiceConst.PROFESSIONAL);
                        if (this.isShippingAddressStepSkip) {
                            this.isEkyc = false;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.consentStepNum = 4;
                            this.confirmStepNum = 5;
                            this.completeStepnum = 6;
                        } else {
                            this.isEkyc = true;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.shippingAddressInfoStepNum = 4;
                            this.consentStepNum = 5;
                            this.confirmStepNum = 6;
                            this.completeStepnum = 7;
                        }
                    } 
                    if (ValueChecker.isPresent(this.applyInfo['additionalTabletPriceBook2Id'])) {
                        this.applyInfo['applyService'].push(ApplyServiceConst.ADDITIONAL_TABLET);
                        this.isEkyc = true;
                        this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                        // ステッパーの順番を決める
                        this.shippingAddressInfoStepNum = 4;
                        this.consentStepNum = 5;
                        this.confirmStepNum = 6;
                        this.completeStepnum = 7;
                    }
                    // standard（旧）対応
                    if (ValueChecker.isPresent(this.applyInfo['oldStandardPriceBook2Id'])) {
                        this.applyInfo['applyService'].push(ApplyServiceConst.OLD_STANDARD);
                        if (this.isShippingAddressStepSkip) {
                            this.isEkyc = false;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.consentStepNum = 4;
                            this.confirmStepNum = 5;
                            this.completeStepnum = 6;
                        } else {
                            this.isEkyc = true;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.shippingAddressInfoStepNum = 4;
                            this.consentStepNum = 5;
                            this.confirmStepNum = 6;
                            this.completeStepnum = 7;
                        }
                    } 
                } else {
                    this.isShippingAddressStepSkip = ValueChecker.isPresent(data['personalEkycSkipFlg']);
                    if (this.isEkycStepMainPlan(this.applyInfo['applyService'])) {
                        // メインプラン + タブレット単体申込みの場合
                        if (this.applyInfo['applyService'].includes(ApplyServiceConst.ADDITIONAL_TABLET)) {
                            this.isEkyc = true;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.shippingAddressInfoStepNum = 4;
                            this.consentStepNum = 5;
                            this.confirmStepNum = 6;
                            this.completeStepnum = 7;
                        // メインプランの場合であり、かつ、本人Ekycをスキップする場合
                        } else if (this.isShippingAddressStepSkip) {
                            this.isEkyc = false;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.consentStepNum = 4;
                            this.confirmStepNum = 5;
                            this.completeStepnum = 6;
                        // メインプランの場合であり、かつ、本人Ekycを実施する場合
                        } else if (!this.isShippingAddressStepSkip) {
                            this.isEkyc = true;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.shippingAddressInfoStepNum = 4;
                            this.consentStepNum = 5;
                            this.confirmStepNum = 6;
                            this.completeStepnum = 7;
                        }
                    } else { 
                        if ((this.applyInfo['applyService'].includes(ApplyServiceConst.BASIC) ||
                             this.applyInfo['applyService'].includes(ApplyServiceConst.MOTION_AI)) &&
                            !this.applyInfo['applyService'].includes(ApplyServiceConst.ADDITIONAL_TABLET)) {
                            // Basic or モーションAIの場合
                            this.isEkyc = false;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.consentStepNum = 4;
                            this.confirmStepNum = 5;
                            this.completeStepnum = 6;
                        } else if (this.applyInfo['applyService'].includes(ApplyServiceConst.ADDITIONAL_TABLET)) {
                            // タブレット単体申込みの場合、若しくは、タブレット単体申込みを含む場合
                            this.isEkyc = true;
                            this.$refs.officeInfo.isEkycCheck(this.isEkyc);
                            // ステッパーの順番を決める
                            this.shippingAddressInfoStepNum = 4;
                            this.consentStepNum = 5;
                            this.confirmStepNum = 6;
                            this.completeStepnum = 7;
                        }
                    }
                }
                this.$refs.applyInfo.setData(this.applyInfo);
                this.requestInfo['companyName'] = data['requestInfoCompanyName'];
                this.requestInfo['requestInfoCompanySameToOfficeInfo'] = data['requestInfoCompanySameToOfficeInfo'];
                this.requestInfo['officeName'] = data['requestInfoOfficeName'];
                this.requestInfo['requestInfoOfficeSameToOfficeInfo'] = data['requestInfoOfficeSameToOfficeInfo'];
                this.requestInfo['zip1'] = data['requestInfoZip1'];
                this.requestInfo['zip2'] = data['requestInfoZip2'];
                this.requestInfo['address1'] = data['requestInfoAddress1'];
                this.requestInfo['address2'] = data['requestInfoAddress2'];
                this.requestInfo['address3'] = data['requestInfoAddress3'];
                this.requestInfo['requestInfoAddressSameToOfficeInfo'] = data['requestInfoAddressSameToOfficeInfo'];
                this.requestInfo['tel'] = data['requestInfoTel'];
                this.requestInfo['requestInfoTelSameToOfficeInfo'] = data['requestInfoTelSameToOfficeInfo'];
                this.requestInfo['requestPersonLastName'] = data['requestInfoRequestPersonLastName'];
                this.requestInfo['requestPersonFirstName'] = data['requestInfoRequestPersonFirstName'];
                this.requestInfo['requestInfoPersonNameSameToOfficeInfo'] = data['requestInfoPersonNameSameToOfficeInfo'];
                this.requestInfo['requestEmail'] = data['requestInfoRequestEmail'];
                this.requestInfo['requestInfoEmailSameToOfficeInfo'] = data['requestInfoEmailSameToOfficeInfo'];
                this.requestInfo['howToRequest'] = data['requestInfoHowToRequest'];
                this.requestInfo['howToSend'] = data['requestInfoHowToSend'];
                this.requestInfo['interimRequestInfoOfficeName'] = data['interimRequestInfoOfficeName'];
                this.requestInfo['interimRequestInfoHojinName'] = data['interimRequestInfoHojinName'];
                this.requestInfo['interimRequestInfoZip1'] = data['interimRequestInfoZip1'];
                this.requestInfo['interimRequestInfoZip2'] = data['interimRequestInfoZip2'];
                this.requestInfo['interimRequestInfoAddress1'] = data['interimRequestInfoAddress1'];
                this.requestInfo['interimRequestInfoAddress2'] = data['interimRequestInfoAddress2'];
                this.requestInfo['interimRequestInfoAddress3'] = data['interimRequestInfoAddress3'];
                this.requestInfo['interimRequestInfoTel'] = data['interimRequestInfoTel'];
                this.requestInfo['interimRequestInfoPersonLastName'] = data['interimRequestInfoPersonLastName'];
                this.requestInfo['interimRequestInfoPersonFirstName'] = data['interimRequestInfoPersonFirstName'];
                this.requestInfo['interimRequestInfoEmail'] = data['interimRequestInfoEmail'];
                this.requestInfo['interimRequestInfoWay'] = data['interimRequestInfoWay'];
                this.requestInfo['interimRequestInfoNotification'] = data['interimRequestInfoNotification'];
                this.requestInfo['requestInfoIsReadOnly'] = data['requestInfoIsReadOnly'];
                this.requestInfo['requestInfoIsReadOnly'] = data['requestInfoIsReadOnly'];
                this.requestInfo['oralCarePriceBookBillWay'] = data['oralCarePriceBookBillWay'];
                this.requestInfo['kobetuPriceBookBillWay'] = data['kobetuPriceBookBillWay'];
                // 配送先情報
                this.shippingAddressInfo['shippingAddressInfoCompanySameToOfficeInfo'] = data['shippingAddressInfoCompanySameToOfficeInfo'];
                this.shippingAddressInfo['shippingAddressInfoPersonNameSameToOfficeInfo'] = data['shippingAddressInfoPersonNameSameToOfficeInfo'];
                this.shippingAddressInfo['shippingAddressInfoOfficeSameToOfficeInfo'] = data['shippingAddressInfoOfficeSameToOfficeInfo'];
                this.shippingAddressInfo['shippingAddressInfoAddressSameToOfficeInfo'] = data['shippingAddressInfoAddressSameToOfficeInfo'];
                this.shippingAddressInfo['shippingAddressInfoTelSameToOfficeInfo'] = data['shippingAddressInfoTelSameToOfficeInfo'];
                this.shippingAddressInfo['companyName'] = data['shippingAddressInfoCompanyName'];
                this.shippingAddressInfo['officeName'] = data['shippingAddressInfoOfficeName'];
                this.shippingAddressInfo['zip1'] = data['shippingAddressInfoZip1'];
                this.shippingAddressInfo['zip2'] = data['shippingAddressInfoZip2'];
                this.shippingAddressInfo['address1'] = data['shippingAddressInfoAddress1'];
                this.shippingAddressInfo['address2'] = data['shippingAddressInfoAddress2'];
                this.shippingAddressInfo['address3'] = data['shippingAddressInfoAddress3'];
                this.shippingAddressInfo['tel'] = data['shippingAddressInfoTel'];
                this.shippingAddressInfo['shippingAddressInfoPersonLastName'] = data['shippingAddressInfoPersonLastName'];
                this.shippingAddressInfo['shippingAddressInfoPersonFirstName'] = data['shippingAddressInfoPersonFirstName'];
                this.$refs.shippingAddressInfo.setData(this.shippingAddressInfo);
                // basic用
                this.requestInfo['basicPriceBookBillWay'] = data['basicPriceBookBillWay'];
                // standard用
                this.requestInfo['standardPriceBookBillWay'] = data['standardPriceBookBillWay'];
                // モーションAI用
                this.requestInfo['motionAiPriceBookBillWay'] = data['motionAiPriceBookBillWay'];
                this.$refs.requestInfo.setData(this.requestInfo);
            },
            isEkycStepMainPlan(applyInfoArray) {
                // eKYC対応のメインプランの場合は、trueを返す。タブレット単体の場合は、含まない。
                const needToEkycMainPlan = 
                    [ApplyServiceConst.ENTRY, 
                    ApplyServiceConst.STANDARD,
                    ApplyServiceConst.OLD_STANDARD,
                    ApplyServiceConst.MEDIUM,
                    ApplyServiceConst.PROFESSIONAL,
                    ApplyServiceConst.UPGRADE];
                    return needToEkycMainPlan.filter(el1 => applyInfoArray.includes(el1)).length > 0; 
            },
            onBack(data, step) {
                if (step) {
                    this.current = step;
                } else {
                    this.refrectData(data);
                    this.current--;
                }
                this.$vuetify.goTo(0, {
                    duration: 1,
                    offset: 0,
                    easing: 'easeInOutCubic'
                });
            },
            onSubmit(data) {
                this.loading = true;
                this.refrectData(data);
                this.nextStep();
                this.loading = false;
            },
            refrectData(data) {
                if (data) {
                    this[data['component']] = data['data'];
                    if (data['component'] === 'officeInfo' && ValueChecker.isBlank(this.requestInfo['requestInfoIsReadOnly']) 
                    ) {
                        this.$refs.requestInfo.isEkycCheck(this.isEkyc);
                        this.$refs.requestInfo.setInitialData(this.officeInfo);
                        this.$refs.shippingAddressInfo.setInitialData(this.officeInfo);
                    } else {
                        this.$refs.requestInfo.isEkycCheck(this.isEkyc);
                        this.$refs.shippingAddressInfo.setInitialData(this.officeInfo);
                    }
                }
            },
            submitComplete(event) {
                let self_ = this;
                self_.loading = true;
                let url_ = self_.$invokeUrlMaker.create(`update/${self_.$route.params.documentId}`);
                let params = JSON.stringify(this.contractDocument);
                axios.post(
                    url_,
                    params
                ).then(
                    function (res) {
                        console.log(res);
                        self_.nextStep();
                        self_.loading = false;
                    }
                ).catch(
                    function (err) {
                        console.log(err);
                        self_.loading = false;
                    }
                );
            },
            nextStep() {
                this.current++;
                this.$vuetify.goTo(0, {
                    duration: 1,
                    offset: 0,
                    easing: 'easeInOutCubic'
                });
            },
            showError() {
                this.hasError = true;
                this.$vuetify.goTo(this.$refs.errorPanel);
            },
            hideError() {
                this.hasError = false;
            },
            getErrorMessage(errors, rule, labelKey, columnName = '') {
                if (errors.length === 0) {
                    return '';
                }
                // 入力必須は、基本的に下記のメッセージ。
                // メッセージを変更したい場合は、ColumnNameを渡す。
                if (rule === 'required' && columnName === '') {
                    let message = this.$t(`view.contract_form.update.label.${labelKey}`);
                    message += this.$t(`view.contract_form.update.messages.error.required`);
                    return message;
                }
                return this.$t(`view.contract_form.update.messages.error.${columnName}`)
            },
            isRequestInfoEditable() {
                return ValueChecker.isBlank(this.requestInfo['requestInfoIsReadOnly']);
            }
        }
    };
</script>
<style>
    .v-stepper--alt-labels .v-stepper__step {
        flex-basis: 200px !important;
    }

    .fixed-label-area {
        height: 100% !important;
        display: flex !important;
    }

    .fixed-label {
        width: 100% !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/contract_form/UpdateForm.vue